import React from 'react';


export default class Loader extends React.Component {

    constructor(props) {
        super(props);
        this.state = {
            display: false,
        };
        this.listeners = [];
    }


    componentDidMount() {
        this.listeners.push(window.sdk.event().on('loadingStart', () => {
            this.setState({
                display: true
            })
        }));
        this.listeners.push(window.sdk.event().on('loadingStop', () => {
            this.setState({
                display: false
            })
        }));
    }

    componentWillUnmount() {
        for (var i in this.listeners) {
            this.listeners[i]();
        }
    }

    render() {
        const { display } = this.state;
        if (!display) {
            return null;
        }
        return(
            <div className="loader">
                <div className="loader__inner">
                    <div className="loader__spinner"></div>
                </div>
            </div>
        )
    }
}